import { useGraphQLQuery } from '@betterment/js-runtime';
import { Card, Heading, Link, Separator, Text } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';

import { EnvelopeRow } from './components/EnvelopeRow';
import { EnvelopesCardDocument } from './graphql/query.envelopesCard.generated';

import { EnvelopeAccountPerformanceHistoryDocument } from '../../account/components/overview-card/graphql/envelopeAccountPerformanceHistory.generated';
import { DateRangeOption } from '../../graphql/schema';
import { Prefetch } from '../../Shared/components-v2/prefetch/Prefetch';

export function EnvelopesCard() {
  const { data } = useGraphQLQuery(EnvelopesCardDocument, { throwOnError: true });
  if (!data) return <CardLoader />;

  const { envelopes } = data;

  if (!envelopes.length) return null;

  const accountsWithoutPurpose = envelopes.flatMap(e =>
    e.purpose ? [] : e.accounts.filter(a => ['ManagedAccount', 'DirectTradingAccount'].includes(a.__typename))
  );
  const queries = accountsWithoutPurpose.map(account => ({
    query: EnvelopeAccountPerformanceHistoryDocument,
    variables: { id: account.id, dateRangeOption: DateRangeOption.AllTime },
    uniqueKey: `EnvelopeAccountPerformanceHistory-${account.id}`,
  }));

  return (
    <Prefetch queries={queries}>
      <Card data-testid="specPageAccountCards">
        <Card.Header css={{ pt: 'space.300', px: 'space.300' }}>
          <Heading as="h2" variant="title200">
            Accounts
          </Heading>
          <Separator css={{ mt: 'space.300' }} />
        </Card.Header>
        <Card.Content>
          {envelopes.map(envelope => (
            <EnvelopeRow key={envelope.id} envelope={envelope} />
          ))}
        </Card.Content>
        <Card.Footer css={{ p: 'space.300' }}>
          <Link href="#disclosures" css={{ _hover: { color: 'text.weak' } }} data-turbolinks="false">
            <Text variant="text50" color="text.weak">
              See disclosures below
            </Text>
          </Link>
        </Card.Footer>
      </Card>
    </Prefetch>
  );
}
